export const PUBLIC_PREFIXES = ['/view/proof-of-delivery', '/pod-upload'];

export function isPublicRoute(path: string = location.pathname): boolean {
  return PUBLIC_PREFIXES.some(p => path.startsWith(p));
}
